import { Center } from '@chakra-ui/react';

export const Error = ({ ...props }) => (
  <Center h="100%" {...props}>
    Something went wrong, try to reload
  </Center>
);
